import { i18n, lngPathCorrector } from 'server/i18n'
import boatLinkGenerator from 'server/boatLinkGenerator'

const getBoatLink = boatLinkGenerator(i18n, lngPathCorrector)

export default getBoatLink
